export default __webpack_public_path__ + "static/media/SWING.a68e150e.png";